import { useState } from 'react'
import { makeStyles, Fab } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Publish'
import DoneIcon from '@material-ui/icons/Done'

const useStyles = makeStyles((theme) => ({
  errorText: {
    margin: '0',
    fontSize: '0.75rem',
    textAlign: 'left',
    fontFamily: 'MontrealRegular',
    fontWeight: '400',
    color: '#f44336'
  },
  successFileLoaded: {
    backgroundColor: '#4dbd74',
    color: 'white',
    '&:hover': {
      backgroundColor: '#469361',
      textDecoration: 'none'
    }
  },
  textOneLine: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  }
}))

const FileInput = (props) => {
  const classes = useStyles()

  const onLoadFile = props.onLoadFile
  const inputName = props.inputName
  const inputError = props.inputError
  const loading = props.loading !== undefined ? props.loading : false
  const buttonLabel = props.buttonLabel
  const validFileFormat = props.validFileFormat

  const [fileName, setFileName] = useState(undefined)

  const loadFile = async (e) => {
    const fileNameLoaded = await onLoadFile(e)
    setFileName(fileNameLoaded)
  }

  return (
    <div>
      <label htmlFor={loading ? '' : inputName} style={{ width: '-webkit-fill-available' }}>
        <input
          style={{ display: 'none' }}
          id={inputName}
          name={inputName}
          type="file"
          accept={validFileFormat}
          onChange={(e) => loadFile(e)}
        />
        <Fab
          color={fileName ? 'success' : 'secondary'}
          size="small"
          component="span"
          aria-label="add"
          variant="extended"
          disabled={loading}
          className={fileName ? classes.successFileLoaded : ''}
          style={{ width: 'inherit' }}
        >
          {fileName ? <DoneIcon /> : <AddIcon />}
          {fileName ? (
            <span className={classes.textOneLine}>{fileName}</span>
          ) : (
            <span className={classes.textOneLine}>{buttonLabel}</span>
          )}
        </Fab>
      </label>
      <p className={classes.errorText}>{inputError}</p>
    </div>
  )
}

export default FileInput
